import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find} from 'lodash';
import {Card, Button, Icon} from 'semantic-ui-react';
import {getTotalQuantity, getNextInfoType, getInfoSalesData} from '../../utils';
import {getMonthShortName} from '../../../../common/util/date';
import {Actions} from '../../../../common/actions';
import BarChart from '../charts/bar';

class SalesByDealers extends Component {
  constructor(props) {
    super(props);
    const isUserTde = props.isUserFromTDE;
    this.state = {
      'infoType': isUserTde ? 'dealers' : 'models',
      'startDate': '',
      'endDate': '',
      'yearSelected': '',
      'monthSelected': '',
      'initialDaySelected': '',
      'finalDaySelected': '',
      'dealerSelected': isUserTde ? '' : props.dealerId,
      'modelSelected': '',
    };
  }

  componentDidMount() {
    const {dateFilters} = this.props;
    this.props.clearHistoricalVehiclesSales();
    if (Object.keys(dateFilters).length) {
      this.updateDateFilterInState();
    }
  }

  componentDidUpdate(prevProps) {
    const previousDateFilters = prevProps.dateFilters;
    const {infoType} = this.state;
    const {dateFilters, salesByDealersList,
      salesByModelsList, salesByColorsList} = this.props;
    if (dateFilters !== previousDateFilters) {
      this.updateDateFilterInState();
    }
    if (
      prevProps.salesByDealersList !== salesByDealersList ||
      prevProps.salesByModelsList !== salesByModelsList ||
      prevProps.salesByColorsList !== salesByColorsList
    ) {
      const total = getTotalQuantity(infoType, this.props);
      this.props.onUpdateTotalQuantity(total);
    }
  }

  getSalesData = () => {
    const {infoType, startDate, endDate, dealerSelected, modelSelected} =
      this.state;
    const queryString = {infoType, startDate, endDate};

    if (dealerSelected) {
      queryString.dealer = dealerSelected;
    }
    if (modelSelected) {
      queryString.model = modelSelected;
    }
    this.props.fetchHistoricalVehiclesSales(queryString);
  }

  updateDateFilterInState() {
    const {dateFilters} = this.props;
    this.setState(
      {
        'startDate': dateFilters.startDate,
        'endDate': dateFilters.endDate,
        'yearSelected': dateFilters.year,
        'monthSelected': dateFilters.month,
        'initialDaySelected': dateFilters.initialDay,
        'finalDaySelected': dateFilters.finalDay,
      },
      () => this.getSalesData()
    );
  }

  onGoToDetailClick = () => {
    const {startDate, endDate, dealerSelected, modelSelected} = this.state;
    const startDateSelected = startDate ? startDate : 'ALL';
    const endDateSelected = endDate ? endDate : 'ALL';
    const dealer = dealerSelected ? dealerSelected : 'ALL';
    const model = modelSelected ? modelSelected : 'ALL';

    this.props.clearHistoricalVehiclesSalesDetail();
    const url = `/kpi/autos/ventas/detalle/${startDateSelected}/${endDateSelected}/${dealer}/${model}`;
    window.open(url, '_blank');
  }

  onBarClick = (code, infoType) => {
    const nextInfoType = getNextInfoType(infoType, 'sales');
    const newState = {
      'infoType': nextInfoType,
    };
    if (nextInfoType === 'models') {
      newState.dealerSelected = code;
    }
    if (nextInfoType === 'colors') {
      newState.modelSelected = code;
    }
    this.setState(newState, () => this.getSalesData());
  }

  clearDateFilters = (type) => {
    this.props.onDateFiltersClear(type);
  }

  onUpdateModelClick = () => {
    this.setState({'infoType': 'models', 'modelSelected': ''}, () => this.getSalesData());
  }

  onUpdateDealerClick = () => {
    this.setState(
      {
        'infoType': 'dealers',
        'dealerSelected': '',
        'modelSelected': '',
      },
      () => this.getSalesData()
    );
  }

  renderYearSelected = () => {
    const {yearSelected} = this.state;
    if (!yearSelected) {
      return null;
    }
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={() => this.clearDateFilters('year')}
      >
        {yearSelected}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderMonthSelected = () => {
    const {monthSelected} = this.state;
    if (!monthSelected) {
      return null;
    }
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={() => this.clearDateFilters('month')}
      >
        {getMonthShortName(monthSelected)}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderDaySelected = () => {
    const {initialDaySelected, finalDaySelected} = this.state;
    if (!initialDaySelected && !finalDaySelected) {
      return null;
    }
    const finalDay = finalDaySelected ? ` - ${finalDaySelected}` : '';
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={() => this.clearDateFilters('day')}
      >
        {initialDaySelected} {finalDay}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderDealerSelected = () => {
    const {dealerSelected} = this.state;
    const {isUserFromTDE, salesByDealersList} = this.props;
    if (!isUserFromTDE || !dealerSelected) {
      return null;
    }
    const dealerInfo = find(salesByDealersList, {'code': dealerSelected}) || {};

    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.onUpdateDealerClick}
      >
        {dealerInfo.name}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderModelSelected = () => {
    const {modelSelected} = this.state;
    if (!modelSelected) {
      return null;
    }
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.onUpdateModelClick}
      >
        {modelSelected}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  clearFiltersSelected = () => {
    const {isUserFromTDE} = this.props;
    const {dealerSelected, modelSelected} = this.state;
    if (isUserFromTDE && dealerSelected) {
      return (
        <Button
          type='button'
          primary
          className='toyota-primary'
          onClick={this.onUpdateDealerClick}
        >
          Limpiar Filtros
          <Icon name='close' size='small' />
        </Button>
      );
    }

    if (modelSelected) {
      return (
        <Button
          type='button'
          primary
          className='toyota-primary'
          onClick={this.onUpdateModelClick}
        >
          Limpiar Filtros
          <Icon name='close' size='small' />
        </Button>
      );
    }
    return null;
  }

  showFiltersSelectedSection = () => {
    return (
      <div className='title-bar filters-selected-section'>
        <div className='title'>
          <h4>Filtros Seleccionados: </h4>
          {this.renderYearSelected()}
          {this.renderMonthSelected()}
          {this.renderDaySelected()}
          {this.renderDealerSelected()}
          {this.renderModelSelected()}
          <div className='title-bar-actions'>
            {this.clearFiltersSelected()}
            <Button
              type='button'
              primary
              className='toyota-primary'
              onClick={this.onGoToDetailClick}
            >
              Ver Detalle
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {loading} = this.props;
    const {infoType} = this.state;
    return (
      <Card fluid raised>
        {this.showFiltersSelectedSection()}
        <BarChart
          loading={loading}
          data={getInfoSalesData(infoType, this.props)}
          infoType={infoType}
          onActiveBarClick={this.onBarClick}
        />
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehiclesKpi.loading,
    'salesByDealersList': state.vehiclesKpi.salesByDealersList,
    'salesByModelsList': state.vehiclesKpi.salesByModelsList,
    'salesByColorsList': state.vehiclesKpi.salesByColorsList,
    'dealerId': state.session.dealerId,
    'isUserFromTDE': state.session.isUserFromTDE,
  };
};

const {
  clearHistoricalVehiclesSales,
  fetchHistoricalVehiclesSales,
  clearHistoricalVehiclesSalesDetail,
} = Actions;

export default connect(mapStateToProps, {
  clearHistoricalVehiclesSales,
  fetchHistoricalVehiclesSales,
  clearHistoricalVehiclesSalesDetail,
})(SalesByDealers);
